import { useGetAllPersons } from '@hr/api/endpoints'
import { IconAverage } from '@hr/common/icons'
import { LoadingContainer } from '@hr/common/loaders/loadingcontainer'
import { average, localized } from '@hr/common/utils'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'
import { determineSalary } from './SalaryLevelsGrouped'

export function SalaryDiffAverage() {
	const { t } = useTranslation()
	const { data: persons } = useGetAllPersons()

	const countDiff = () => {
		const men = []
		const women = []
		persons.forEach((person) => {
			const status = person.employmentDetails?.personStatus
			if ((status === 'EMPLOYED' || !status) && person.socSec) {
				const { salaryDetails } = person
				if (salaryDetails) {
					const salary = determineSalary(salaryDetails)
					if (salary) {
						const g = (person.gender || '').trim().toUpperCase()
						if (g === 'M') men.push(salary)
						else if (g === 'N') women.push(salary)
					}
				}
			}
		})

		const menAverage = average(men) || 0
		const womenAverage = average(women) || 0
		const diff = Math.abs(menAverage - womenAverage)
		const gap = Math.max(menAverage, womenAverage) === 0 ? 0 : diff / Math.max(menAverage, womenAverage)

		return (
			<>
				<h4 className={styles.cardHeader}>{t('SalaryDiffAverage', 'Palkkaero % (keskiarvo)')}</h4>
				<IconAverage />
				<b className={styles.bigFigure}>{`${localized.numberFormatFraction1.format(gap * 100)} %`}</b>
			</>
		)
	}

	return persons ? countDiff() : <LoadingContainer />
}
